import { ReactElement, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";

import "./change-list.scss";
import CustomTable from "../../components/custom-table/custom-table";
import Heading from "../../components/heading/heading.component";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import { useDispatch } from "react-redux";
import {
  ADD_TO_BREADCRUMB,
  LOADING,
  REMOVE_FROM_BREADCRUMB,
} from "../../store/actions";
import { AxiosResponse } from "axios";
import instance from "../../store/axios";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import clsx from "clsx";
import { isDate } from "../../utils/helper/functions";
import moment from "moment";

const mappingToDescriptoin = {
  sourceOfIncome1Amt:
    "Total annual income from salary, financial incentives and allowances",
  sourceOfIncome2Amt: "Total annual income from personal business",
  sourceOfIncome3Amt: "Total annual pension income",
  sourceOfIncome4Amt:
    "Total annual cash dividends from investments inlocal / foreign securities",
  sourceOfIncome5Amt: "Total annual income from local / foreign realestate",
  sourceOfIncome6Amt:
    "Total annual income from contributions in local /foreign real estate funds and/or projects",
  sourceOfIncome7Amt: "Total interest from bank deposits",
  sourceOfWealth1Amt: "Savings accounts with local / foreign banks",
  sourceOfWealth2Amt: "Credit facilities from local / foreign banks",
  sourceOfWealth3Amt: "Inheritance",
  sourceOfWealth4Amt:
    "Local / foreign real estate (Except for theresidential houses)",
  sourceOfWealth5Amt: "Investments in local / foreign real estateprojects",
  sourceOfWealth6Amt: "Investments in local / foreign securities",
};

const ChangeList: React.FC = (): ReactElement => {
  const { accountId, kycId } = useParams();
  const dispatch = useDispatch();
  const [changeListData, setChangeListData] = useState([]);

  useEffect(() => {
    getHistoryKyc();
    dispatch({
      type: ADD_TO_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: `Change list`,
            type: "text",
          },
        ],
      },
    });

    return () => {
      dispatch({
        type: REMOVE_FROM_BREADCRUMB,
        payload: {
          breadcrumb: [
            {
              text: `Change list`,
            },
          ],
        },
      });
    };
  }, []);

  const getHistoryKyc = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/change-list?kycId=${kycId}`
      );
      const baseKeys = new Set(response?.data?.data.map((item) => item.key));
      const filteredData = response?.data?.data.filter((item) => {
        const baseKey = item.key.replace(/Id$/, "");
        return !baseKeys.has(baseKey) || !item.key.endsWith("Id");
      });

      setChangeListData(filteredData);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/customers/change-list/${accountId}/${kycId}`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  const columns: ColumnsType<any> = [
    {
      title: "Changes Field",
      dataIndex: "key",
      key: "key",
      fixed: "left",
      render: (text) => <span>{mappingToDescriptoin[text] || text}</span>,
    },
    {
      title: "Old value",
      dataIndex: "oldValue",
      key: "oldValue",
      render: (text, record) =>
        record?.key === "isActive" || record?.key === "locked" ? (
          <span
            className={clsx(
              "rounded-md text-sm w-[100px] flex items-center justify-center h-[35px]",
              !text ? "bg-red-200 text-white" : "bg-gray-600 text-green-500"
            )}
          >
            {record?.key === "isActive" && <>{text ? "Active" : "Inactive"}</>}
            {record?.key === "locked" && <>{text ? "Locked" : "Pending"}</>}
          </span>
        ) : typeof text == "boolean" ? (
          <span>{text ? "Yes" : "No"}</span>
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "Updated value",
      dataIndex: "newValue",
      key: "newValue",
      render: (text, record) =>
        record?.key === "isActive" || record?.key === "locked" ? (
          <span
            className={clsx(
              "rounded-md text-sm w-[100px] flex items-center justify-center h-[35px]",
              !text ? "bg-red-200 text-white" : "bg-gray-600 text-green-500"
            )}
          >
            {record?.key === "isActive" && <>{text ? "Active" : "Inactive"}</>}
            {record?.key === "locked" && <>{text ? "Locked" : "Pending"}</>}
          </span>
        ) : typeof text == "boolean" ? (
          <span>{text ? "Yes" : "No"}</span>
        ) : (
          <span>{text}</span>
        ),
    },
  ];

  return (
    <div className="change-list-container flex flex-col">
      <BreadcrumbComponent />

      <Heading
        text="KYC change list"
        size={4}
        style={{
          fontSize: "18px",
          color: "#000",
          fontWeight: "500",
          marginBottom: "20px",
        }}
      />
      <div className="customers-table">
        <CustomTable
          columns={columns}
          data={changeListData}
          showPagination={false}
        />
      </div>
    </div>
  );
};

export default ChangeList;
